import jssVariables from "../../jss_setup";

export const hotels = {
  hotelsList: {
    gridGap: jssVariables.double_gap,
    smallscreen: {
      padding: jssVariables.spacing.center_padding_medium,
    },
  },
};

export const hotelStyles = {
  hotel: {
    gridGap: jssVariables.normal_gap,
    boxShadow: "none",
    smallscreen: {
      boxShadow: "none",
    },
  },
  imgContainer: {
    boxShadow: jssVariables.shadows.smallShadow,
    borderRadius: jssVariables.border_radius,
    smallscreen: {
      borderRadius: jssVariables.border_radius,
    },
  },
  img: {
    borderRadius: jssVariables.border_radius,
    smallscreen: {
      borderRadius: jssVariables.border_radius,
    },
  },
  imgOverlay: {
    borderRadius: jssVariables.border_radius,
    smallscreen: {
      borderRadius: jssVariables.border_radius,
    },
  },
  placeholderImg: {
    borderRadius: `${jssVariables.border_radius}!important`,
    boxShadow: jssVariables.shadows.smallShadow,
    smallscreen: {
      borderRadius: `${jssVariables.border_radius}!important`,
    },
  },
  contentAndBtmContr: {
    boxShadow: jssVariables.shadows.smallShadow,
    borderRadius: jssVariables.border_radius,
    smallscreen: {
      boxShadow: jssVariables.shadows.smallShadow,
    },
  },
};

export const hotelBottomContainer = {
  BottomContainer: {
    alignItems: "center",
    justifySelf: "end",
  },
  priceContainer: {
    smallscreen: {
      justifyItems: "end",
    },
  },
};

export const landingPageHotelStyles = {
  hotel: {
    borderRadius: jssVariables.border_radius,
    boxShadow: "none",
    gridGap: jssVariables.normal_gap,
  },
  imgContainer: {
    boxShadow: jssVariables.shadows.smallShadow,
    smallscreen: {
      borderRadius: jssVariables.border_radius,
    },
  },
  img: {
    borderRadius: jssVariables.border_radius,
    smallscreen: {
      borderRadius: jssVariables.border_radius,
    },
  },
  imgOverlay: {
    borderRadius: jssVariables.border_radius,
    smallscreen: {
      borderRadius: jssVariables.border_radius,
    },
  },
  placeholderImg: {
    borderRadius: jssVariables.border_radius,
  },
  contentAndBtmContr: {
    boxShadow: jssVariables.shadows.smallShadow,
    borderRadius: jssVariables.border_radius,
    smallscreen: {
      boxShadow: jssVariables.shadows.smallShadow,
    },
  },
};

export const hotelBottomContainerMobileView = {
  BottomContainer: {
    justifyItems: "end",
    gridTemplateColumns: "1fr",
  },
  divider: {
    smallscreen: {
      display: "block",
      width: "100%",
      height: "1px",
      background: jssVariables.colors.border,
      marginLeft: 0,
    },
  },
};

export const hotelFilters = {
  Filters: {
    borderRadius: jssVariables.border_radius,
  },
};

export const HotelDetailsMapContainer = {
  placeholder: {
    borderRadius: jssVariables.double_gap,
  },
  mapStyles: {
    map: {
      borderRadius: jssVariables.double_gap,
    },
  },
};

export const SelectRoomBtn = {
  notAvailableBtn: {
    borderRadius: jssVariables.half_gap,
  },
};

export const roomGroup = {
  RoomGroup: {
    borderRadius: jssVariables.normal_gap,
  },
  header: {
    borderRadius: [jssVariables.normal_gap, jssVariables.normal_gap, 0, 0],
  },
};
